import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as selectors from 'shared/redux/reducers'
import { toggleAutoPlay } from 'shared/redux/auto-play'
import { channelSearch } from 'shared/api'
import Header from '../components/header/header'

@connect(
    state => ({
        searchResponseId: selectors.getResponseId(state),
        autoPlay: selectors.getAutoPlay(state),
        isSticker: selectors.getSearchType(state) === 'sticker',
    }),
    { toggleAutoPlay },
)
export default class HeaderContainer extends PureComponent {
    state = {
        channels: undefined,
    }
    async componentDidMount() {
        const { searchInfo } = this.props
        if (searchInfo) {
            const channels = await channelSearch(searchInfo.term)
            this.setState({ channels })
        }
    }
    render() {
        const { channels } = this.state
        return <Header {...this.props} channels={channels} />
    }
}
